import React from "react";
import Section from "../ui/Section/Section";
import { Grid } from "../ui/Grid/Grid";
import KpiCard from "../ui/Card/KpiCard";
import ChartCard from "../ui/Card/ChartCard";
import GaugeStat from "../ui/GaugeStat/GaugeStat";
import DeltaValue from "../ui/DeltaValue/DeltaValue";
import SectionSkeleton from "../ui/SectionSkeleton/SectionSkeleton";
import { KPI, SECTIONS } from "../../constants";
import { fmt1, fmt1OrDash, fmt1Signed } from "../../functions/format";
import { pctChange } from "../../functions/mapEffectif";
import { CHART_COLORS } from "../../styles/theme";

const { id, title } = SECTIONS.retention;

const SKELETON_ROWS = [
    { cols: 3, cards: [3, 3, 3] },
    { cols: 3, cards: [1, 1] },
];

/** Textes des tooltips "vs précédent" ; ajuster les suffixes ici. */
const formatPointDeltaTip = (current, previous) =>
    current !== null &&
    current !== undefined &&
    previous !== null &&
    previous !== undefined
        ? `${fmt1Signed(current - previous)} pt vs précédent`
        : undefined;

const formatPctDeltaTip = (current, previous) => {
    if (current === null || current === undefined) return undefined;
    const delta = pctChange(current, previous);
    return delta !== null ? `${fmt1Signed(delta)}% vs précédent` : undefined;
};

const RetentionSection = ({ data, isLoading }) => {
    if (isLoading && !data) {
        return (
            <Section id={id} title={title}>
                <SectionSkeleton rows={SKELETON_ROWS} />
            </Section>
        );
    }

    if (!data) return null;

    const gauges = [
        {
            key: "retention",
            title: "Taux de rétention",
            pct: data.tauxRetention,
            previous: data.tauxRetentionPrevious,
            color: CHART_COLORS.violet,
            sub: "sur 12 mois",
        },
        {
            key: "essai",
            title: "Confirmation période d’essai",
            pct: data.confirmationEssai,
            previous: data.confirmationEssaiPrevious,
            color: CHART_COLORS.violet,
            sub: "des recrutements",
        },
        {
            key: "recrutement",
            title: "Recrutement réussi (12 mois)",
            pct: data.recrutementReussi,
            previous: data.recrutementReussiPrevious,
            color: CHART_COLORS.blue,
            sub: "encore présents",
        },
    ];

    return (
        <Section id={id} title={title}>
            <Grid cols={3}>
                {gauges.map((g) => (
                    <ChartCard key={g.key} title={g.title}>
                        <GaugeStat
                            pct={g.pct ?? 0}
                            color={g.color}
                            unit={g.pct === null ? undefined : "%"}
                            sub={g.sub}
                            value={
                                <DeltaValue
                                    section={id}
                                    tip={formatPointDeltaTip(
                                        g.pct,
                                        g.previous
                                    )}
                                >
                                    {fmt1OrDash(g.pct)}
                                </DeltaValue>
                            }
                            tip={
                                g.pct === null
                                    ? undefined
                                    : `${g.title} : ${fmt1(g.pct)} % ${g.sub}`
                            }
                        />
                    </ChartCard>
                ))}
            </Grid>
            <Grid cols={3} $mt>
                <KpiCard
                    label={KPI.anciennete.label}
                    unit={KPI.anciennete.unit}
                    value={fmt1OrDash(data.anciennete)}
                    section={id}
                    tip={formatPctDeltaTip(
                        data.anciennete,
                        data.anciennetePrevious
                    )}
                />
                <KpiCard
                    label={KPI.mobilite.label}
                    unit={KPI.mobilite.unit}
                    value={fmt1OrDash(data.mobilite)}
                    section={id}
                    tip={formatPointDeltaTip(
                        data.mobilite,
                        data.mobilitePrevious
                    )}
                />
            </Grid>
        </Section>
    );
};

export default RetentionSection;
